
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import PlatformMarkerStack2 from "../../editor/platform-markers/cave/PlatformMarkerStack2";
import PlatformMarkerPlatMid from "../../editor/platform-markers/cave/PlatformMarkerPlatMid";
import SmashableMarkerRocks from "../../editor/entity-markers/SmashableMarkerRocks";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerRock from "../../editor/platform-markers/cave/PlatformMarkerRock";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunkHard2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 10285, 368);
    this.add(editor_bounds_right);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 473, 128);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 350, 131);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 613, 131);
    this.add(gemMarker_3);

    // platformMarkerStack_12
    const platformMarkerStack_12 = new PlatformMarkerStack3(scene, 1681, 277);
    this.add(platformMarkerStack_12);

    // platformMarkerStack_13
    const platformMarkerStack_13 = new PlatformMarkerStack3(scene, 2032, 273);
    this.add(platformMarkerStack_13);

    // platformMarkerStack2
    const platformMarkerStack2 = new PlatformMarkerStack2(scene, 289, 304);
    this.add(platformMarkerStack2);

    // platformMarkerStack
    const platformMarkerStack = new PlatformMarkerStack2(scene, 661, 304);
    this.add(platformMarkerStack);

    // platformMarkerPlatMid_1
    const platformMarkerPlatMid_1 = new PlatformMarkerPlatMid(scene, 477, 218);
    this.add(platformMarkerPlatMid_1);

    // platformMarkerPlatMid_2
    const platformMarkerPlatMid_2 = new PlatformMarkerPlatMid(scene, 1858, 163);
    this.add(platformMarkerPlatMid_2);

    // platformMarkerStack_1
    const platformMarkerStack_1 = new PlatformMarkerStack3(scene, 2243, 284);
    this.add(platformMarkerStack_1);

    // platformMarkerStack_2
    const platformMarkerStack_2 = new PlatformMarkerStack3(scene, 2594, 280);
    this.add(platformMarkerStack_2);

    // platformMarkerPlatMid
    const platformMarkerPlatMid = new PlatformMarkerPlatMid(scene, 2420, 170);
    this.add(platformMarkerPlatMid);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 2892, -72);
    this.add(gemMarker_4);

    // smashableMarkerRocks_1
    const smashableMarkerRocks_1 = new SmashableMarkerRocks(scene, 2425, -34);
    this.add(smashableMarkerRocks_1);

    // smashableMarkerRocks
    const smashableMarkerRocks = new SmashableMarkerRocks(scene, 3685, -33);
    this.add(smashableMarkerRocks);

    // platformMarkerPlatMid_4
    const platformMarkerPlatMid_4 = new PlatformMarkerPlatMid(scene, 2430, -233);
    this.add(platformMarkerPlatMid_4);

    // platformMarkerPlatMid_5
    const platformMarkerPlatMid_5 = new PlatformMarkerPlatMid(scene, 3689, -229);
    this.add(platformMarkerPlatMid_5);

    // platformMarkerStack_5
    const platformMarkerStack_5 = new PlatformMarkerStack3(scene, 3512, 291);
    this.add(platformMarkerStack_5);

    // platformMarkerPlatMid_6
    const platformMarkerPlatMid_6 = new PlatformMarkerPlatMid(scene, 3689, 177);
    this.add(platformMarkerPlatMid_6);

    // platformMarkerStack_6
    const platformMarkerStack_6 = new PlatformMarkerStack3(scene, 3863, 287);
    this.add(platformMarkerStack_6);

    // platformMarkerPlatMid_7
    const platformMarkerPlatMid_7 = new PlatformMarkerPlatMid(scene, 3058, 2);
    this.add(platformMarkerPlatMid_7);

    // smashableMarkerRocks_2
    const smashableMarkerRocks_2 = new SmashableMarkerRocks(scene, 3691, -429);
    this.add(smashableMarkerRocks_2);

    // platformMarkerPlatMid_8
    const platformMarkerPlatMid_8 = new PlatformMarkerPlatMid(scene, 3698, -621);
    this.add(platformMarkerPlatMid_8);

    // trapMarkerTorch_12
    const trapMarkerTorch_12 = new TrapMarkerTorch(scene, 3041, -72);
    this.add(trapMarkerTorch_12);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 4185, -93);
    this.add(gemMarker_5);

    // platformMarkerPlatMid_9
    const platformMarkerPlatMid_9 = new PlatformMarkerPlatMid(scene, 4357, 2);
    this.add(platformMarkerPlatMid_9);

    // smashableMarkerRocks_3
    const smashableMarkerRocks_3 = new SmashableMarkerRocks(scene, 5030, -415);
    this.add(smashableMarkerRocks_3);

    // platformMarkerPlatMid_11
    const platformMarkerPlatMid_11 = new PlatformMarkerPlatMid(scene, 5027, -607);
    this.add(platformMarkerPlatMid_11);

    // trapMarkerTorch
    const trapMarkerTorch = new TrapMarkerTorch(scene, 4356, -84);
    this.add(trapMarkerTorch);

    // platformMarkerPlatMid_12
    const platformMarkerPlatMid_12 = new PlatformMarkerPlatMid(scene, 4357, -431);
    this.add(platformMarkerPlatMid_12);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 3199, -75);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 4480, -103);
    this.add(gemMarker_7);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 2577, 95);
    this.add(megaGemMarker_1);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3857, -304);
    this.add(megaGemMarker);

    // platformMarkerRock
    const platformMarkerRock = new PlatformMarkerRock(scene, 1163, 317);
    this.add(platformMarkerRock);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1166, 182);
    this.add(gemMarker);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 1839, 63);
    this.add(gemMarker_8);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 1716, 66);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 1979, 66);
    this.add(gemMarker_10);

    // platformMarkerPlatMid_13
    const platformMarkerPlatMid_13 = new PlatformMarkerPlatMid(scene, 4357, -834);
    this.add(platformMarkerPlatMid_13);

    // platformMarkerPlatMid_16
    const platformMarkerPlatMid_16 = new PlatformMarkerPlatMid(scene, 5027, -1015);
    this.add(platformMarkerPlatMid_16);

    // smashableMarkerRocks_6
    const smashableMarkerRocks_6 = new SmashableMarkerRocks(scene, 4353, -638);
    this.add(smashableMarkerRocks_6);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 4511, -501);
    this.add(megaGemMarker_2);

    // smashableMarkerRocks_4
    const smashableMarkerRocks_4 = new SmashableMarkerRocks(scene, 5023, -35);
    this.add(smashableMarkerRocks_4);

    // platformMarkerPlatMid_14
    const platformMarkerPlatMid_14 = new PlatformMarkerPlatMid(scene, 5027, -231);
    this.add(platformMarkerPlatMid_14);

    // platformMarkerStack_9
    const platformMarkerStack_9 = new PlatformMarkerStack3(scene, 4850, 289);
    this.add(platformMarkerStack_9);

    // platformMarkerPlatMid_15
    const platformMarkerPlatMid_15 = new PlatformMarkerPlatMid(scene, 5027, 175);
    this.add(platformMarkerPlatMid_15);

    // platformMarkerStack_10
    const platformMarkerStack_10 = new PlatformMarkerStack3(scene, 5201, 285);
    this.add(platformMarkerStack_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 5523, -119);
    this.add(gemMarker_11);

    // platformMarkerPlatMid_17
    const platformMarkerPlatMid_17 = new PlatformMarkerPlatMid(scene, 5687, 0);
    this.add(platformMarkerPlatMid_17);

    // smashableMarkerRocks_5
    const smashableMarkerRocks_5 = new SmashableMarkerRocks(scene, 6474, -417);
    this.add(smashableMarkerRocks_5);

    // platformMarkerPlatMid_19
    const platformMarkerPlatMid_19 = new PlatformMarkerPlatMid(scene, 6479, -609);
    this.add(platformMarkerPlatMid_19);

    // trapMarkerTorch_1
    const trapMarkerTorch_1 = new TrapMarkerTorch(scene, 5687, -85);
    this.add(trapMarkerTorch_1);

    // platformMarkerPlatMid_20
    const platformMarkerPlatMid_20 = new PlatformMarkerPlatMid(scene, 5687, -433);
    this.add(platformMarkerPlatMid_20);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 5818, -115);
    this.add(gemMarker_12);

    // platformMarkerPlatMid_21
    const platformMarkerPlatMid_21 = new PlatformMarkerPlatMid(scene, 5687, -836);
    this.add(platformMarkerPlatMid_21);

    // platformMarkerPlatMid_22
    const platformMarkerPlatMid_22 = new PlatformMarkerPlatMid(scene, 6479, -1017);
    this.add(platformMarkerPlatMid_22);

    // smashableMarkerRocks_7
    const smashableMarkerRocks_7 = new SmashableMarkerRocks(scene, 5691, -640);
    this.add(smashableMarkerRocks_7);

    // megaGemMarker_4
    const megaGemMarker_4 = new MegaGemMarker(scene, 5849, -503);
    this.add(megaGemMarker_4);

    // platformMarkerStack_15
    const platformMarkerStack_15 = new PlatformMarkerStack3(scene, 9558, 299);
    this.add(platformMarkerStack_15);

    // platformMarkerStack_16
    const platformMarkerStack_16 = new PlatformMarkerStack3(scene, 9909, 295);
    this.add(platformMarkerStack_16);

    // platformMarkerPlatMid_23
    const platformMarkerPlatMid_23 = new PlatformMarkerPlatMid(scene, 9735, 185);
    this.add(platformMarkerPlatMid_23);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 9716, 85);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 9593, 88);
    this.add(gemMarker_14);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 9856, 88);
    this.add(gemMarker_15);

    // platformMarkerPlatMid_25
    const platformMarkerPlatMid_25 = new PlatformMarkerPlatMid(scene, 6479, -222);
    this.add(platformMarkerPlatMid_25);

    // trapMarkerTorch_2
    const trapMarkerTorch_2 = new TrapMarkerTorch(scene, 4368, -920);
    this.add(trapMarkerTorch_2);

    // trapMarkerTorch_3
    const trapMarkerTorch_3 = new TrapMarkerTorch(scene, 5046, -1094);
    this.add(trapMarkerTorch_3);

    // trapMarkerTorch_4
    const trapMarkerTorch_4 = new TrapMarkerTorch(scene, 5701, -916);
    this.add(trapMarkerTorch_4);

    // trapMarkerTorch_5
    const trapMarkerTorch_5 = new TrapMarkerTorch(scene, 6495, -1096);
    this.add(trapMarkerTorch_5);

    // smashableMarkerRocks_8
    const smashableMarkerRocks_8 = new SmashableMarkerRocks(scene, 6475, -27);
    this.add(smashableMarkerRocks_8);

    // platformMarkerStack_17
    const platformMarkerStack_17 = new PlatformMarkerStack3(scene, 6302, 297);
    this.add(platformMarkerStack_17);

    // platformMarkerPlatMid_26
    const platformMarkerPlatMid_26 = new PlatformMarkerPlatMid(scene, 6479, 183);
    this.add(platformMarkerPlatMid_26);

    // platformMarkerStack_18
    const platformMarkerStack_18 = new PlatformMarkerStack3(scene, 6653, 293);
    this.add(platformMarkerStack_18);

    // megaGemMarker_5
    const megaGemMarker_5 = new MegaGemMarker(scene, 6647, 109);
    this.add(megaGemMarker_5);

    // platformMarkerStack_3
    const platformMarkerStack_3 = new PlatformMarkerStack1(scene, 4357, 355);
    this.add(platformMarkerStack_3);

    // platformMarkerStack_4
    const platformMarkerStack_4 = new PlatformMarkerStack1(scene, 5708, 348);
    this.add(platformMarkerStack_4);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 6952, -122);
    this.add(gemMarker_16);

    // platformMarkerPlatMid_3
    const platformMarkerPlatMid_3 = new PlatformMarkerPlatMid(scene, 7116, -7);
    this.add(platformMarkerPlatMid_3);

    // trapMarkerTorch_6
    const trapMarkerTorch_6 = new TrapMarkerTorch(scene, 7116, -88);
    this.add(trapMarkerTorch_6);

    // platformMarkerPlatMid_10
    const platformMarkerPlatMid_10 = new PlatformMarkerPlatMid(scene, 7116, -440);
    this.add(platformMarkerPlatMid_10);

    // gemMarker_17
    const gemMarker_17 = new SmallGemMarker(scene, 7247, -132);
    this.add(gemMarker_17);

    // platformMarkerPlatMid_18
    const platformMarkerPlatMid_18 = new PlatformMarkerPlatMid(scene, 7116, -843);
    this.add(platformMarkerPlatMid_18);

    // smashableMarkerRocks_9
    const smashableMarkerRocks_9 = new SmashableMarkerRocks(scene, 7120, -647);
    this.add(smashableMarkerRocks_9);

    // megaGemMarker_6
    const megaGemMarker_6 = new MegaGemMarker(scene, 7278, -510);
    this.add(megaGemMarker_6);

    // trapMarkerTorch_7
    const trapMarkerTorch_7 = new TrapMarkerTorch(scene, 7120, -929);
    this.add(trapMarkerTorch_7);

    // platformMarkerStack_7
    const platformMarkerStack_7 = new PlatformMarkerStack1(scene, 7105, 346);
    this.add(platformMarkerStack_7);

    // smashableMarkerRocks_11
    const smashableMarkerRocks_11 = new SmashableMarkerRocks(scene, 7720, -40);
    this.add(smashableMarkerRocks_11);

    // platformMarkerPlatMid_28
    const platformMarkerPlatMid_28 = new PlatformMarkerPlatMid(scene, 7724, -236);
    this.add(platformMarkerPlatMid_28);

    // platformMarkerStack_14
    const platformMarkerStack_14 = new PlatformMarkerStack3(scene, 7547, 284);
    this.add(platformMarkerStack_14);

    // platformMarkerPlatMid_29
    const platformMarkerPlatMid_29 = new PlatformMarkerPlatMid(scene, 7724, 170);
    this.add(platformMarkerPlatMid_29);

    // platformMarkerStack_19
    const platformMarkerStack_19 = new PlatformMarkerStack3(scene, 7898, 280);
    this.add(platformMarkerStack_19);

    // smashableMarkerRocks_12
    const smashableMarkerRocks_12 = new SmashableMarkerRocks(scene, 7726, -436);
    this.add(smashableMarkerRocks_12);

    // platformMarkerPlatMid_30
    const platformMarkerPlatMid_30 = new PlatformMarkerPlatMid(scene, 7724, -628);
    this.add(platformMarkerPlatMid_30);

    // megaGemMarker_8
    const megaGemMarker_8 = new MegaGemMarker(scene, 7892, 96);
    this.add(megaGemMarker_8);

    // platformMarkerStack_20
    const platformMarkerStack_20 = new PlatformMarkerStack3(scene, 8892, 305);
    this.add(platformMarkerStack_20);

    // platformMarkerStack_21
    const platformMarkerStack_21 = new PlatformMarkerStack3(scene, 9243, 301);
    this.add(platformMarkerStack_21);

    // platformMarkerPlatMid_31
    const platformMarkerPlatMid_31 = new PlatformMarkerPlatMid(scene, 9069, 191);
    this.add(platformMarkerPlatMid_31);

    // gemMarker_18
    const gemMarker_18 = new SmallGemMarker(scene, 8251, -91);
    this.add(gemMarker_18);

    // smashableMarkerRocks_13
    const smashableMarkerRocks_13 = new SmashableMarkerRocks(scene, 9074, -13);
    this.add(smashableMarkerRocks_13);

    // platformMarkerPlatMid_32
    const platformMarkerPlatMid_32 = new PlatformMarkerPlatMid(scene, 9079, -212);
    this.add(platformMarkerPlatMid_32);

    // platformMarkerPlatMid_33
    const platformMarkerPlatMid_33 = new PlatformMarkerPlatMid(scene, 8417, -17);
    this.add(platformMarkerPlatMid_33);

    // trapMarkerTorch_8
    const trapMarkerTorch_8 = new TrapMarkerTorch(scene, 8412, -97);
    this.add(trapMarkerTorch_8);

    // gemMarker_19
    const gemMarker_19 = new SmallGemMarker(scene, 8558, -94);
    this.add(gemMarker_19);

    // megaGemMarker_9
    const megaGemMarker_9 = new MegaGemMarker(scene, 9226, 116);
    this.add(megaGemMarker_9);

    // trapMarkerTorch_9
    const trapMarkerTorch_9 = new TrapMarkerTorch(scene, 6484, -695);
    this.add(trapMarkerTorch_9);

    // trapMarkerTorch_10
    const trapMarkerTorch_10 = new TrapMarkerTorch(scene, 5041, -693);
    this.add(trapMarkerTorch_10);

    // trapMarkerTorch_11
    const trapMarkerTorch_11 = new TrapMarkerTorch(scene, 7745, -715);
    this.add(trapMarkerTorch_11);

    // trapMarkerTorch_13
    const trapMarkerTorch_13 = new TrapMarkerTorch(scene, 3704, -710);
    this.add(trapMarkerTorch_13);

    // gemMarker_20
    const gemMarker_20 = new SmallGemMarker(scene, 6638, -730);
    this.add(gemMarker_20);

    // gemMarker_21
    const gemMarker_21 = new SmallGemMarker(scene, 6343, -730);
    this.add(gemMarker_21);

    // gemMarker_22
    const gemMarker_22 = new SmallGemMarker(scene, 6650, -1121);
    this.add(gemMarker_22);

    // gemMarker_23
    const gemMarker_23 = new SmallGemMarker(scene, 6355, -1121);
    this.add(gemMarker_23);

    // gemMarker_24
    const gemMarker_24 = new SmallGemMarker(scene, 5846, -968);
    this.add(gemMarker_24);

    // gemMarker_25
    const gemMarker_25 = new SmallGemMarker(scene, 5551, -968);
    this.add(gemMarker_25);

    // gemMarker_26
    const gemMarker_26 = new SmallGemMarker(scene, 5188, -1141);
    this.add(gemMarker_26);

    // gemMarker_27
    const gemMarker_27 = new SmallGemMarker(scene, 4893, -1141);
    this.add(gemMarker_27);

    // gemMarker_28
    const gemMarker_28 = new SmallGemMarker(scene, 5184, -705);
    this.add(gemMarker_28);

    // gemMarker_29
    const gemMarker_29 = new SmallGemMarker(scene, 4889, -705);
    this.add(gemMarker_29);

    // gemMarker_30
    const gemMarker_30 = new SmallGemMarker(scene, 4519, -962);
    this.add(gemMarker_30);

    // gemMarker_31
    const gemMarker_31 = new SmallGemMarker(scene, 4224, -962);
    this.add(gemMarker_31);

    // gemMarker_33
    const gemMarker_33 = new SmallGemMarker(scene, 3549, -342);
    this.add(gemMarker_33);

    // gemMarker_34
    const gemMarker_34 = new SmallGemMarker(scene, 3842, 75);
    this.add(gemMarker_34);

    // gemMarker_35
    const gemMarker_35 = new SmallGemMarker(scene, 3547, 75);
    this.add(gemMarker_35);

    // megaGemMarker_7
    const megaGemMarker_7 = new MegaGemMarker(scene, 5195, -302);
    this.add(megaGemMarker_7);

    // gemMarker_32
    const gemMarker_32 = new SmallGemMarker(scene, 4874, 59);
    this.add(gemMarker_32);

    // gemMarker_36
    const gemMarker_36 = new SmallGemMarker(scene, 5169, 59);
    this.add(gemMarker_36);

    // gemMarker_37
    const gemMarker_37 = new SmallGemMarker(scene, 4883, -362);
    this.add(gemMarker_37);

    // gemMarker_38
    const gemMarker_38 = new SmallGemMarker(scene, 5532, -555);
    this.add(gemMarker_38);

    // gemMarker_39
    const gemMarker_39 = new SmallGemMarker(scene, 6635, -361);
    this.add(gemMarker_39);

    // gemMarker_40
    const gemMarker_40 = new SmallGemMarker(scene, 6340, -361);
    this.add(gemMarker_40);

    // gemMarker_41
    const gemMarker_41 = new SmallGemMarker(scene, 6330, 50);
    this.add(gemMarker_41);

    // gemMarker_42
    const gemMarker_42 = new SmallGemMarker(scene, 6976, -576);
    this.add(gemMarker_42);

    // gemMarker_43
    const gemMarker_43 = new SmallGemMarker(scene, 4193, -559);
    this.add(gemMarker_43);

    // gemMarker_44
    const gemMarker_44 = new SmallGemMarker(scene, 7271, -972);
    this.add(gemMarker_44);

    // gemMarker_45
    const gemMarker_45 = new SmallGemMarker(scene, 6976, -972);
    this.add(gemMarker_45);

    // gemMarker_46
    const gemMarker_46 = new SmallGemMarker(scene, 7894, -753);
    this.add(gemMarker_46);

    // gemMarker_47
    const gemMarker_47 = new SmallGemMarker(scene, 7599, -753);
    this.add(gemMarker_47);

    // gemMarker_48
    const gemMarker_48 = new SmallGemMarker(scene, 9251, -318);
    this.add(gemMarker_48);

    // gemMarker_49
    const gemMarker_49 = new SmallGemMarker(scene, 8956, -318);
    this.add(gemMarker_49);

    // gemMarker_50
    const gemMarker_50 = new SmallGemMarker(scene, 7882, -350);
    this.add(gemMarker_50);

    // gemMarker_51
    const gemMarker_51 = new SmallGemMarker(scene, 7587, -350);
    this.add(gemMarker_51);

    // trapMarkerTorch_14
    const trapMarkerTorch_14 = new TrapMarkerTorch(scene, 2232, -323);
    this.add(trapMarkerTorch_14);

    // trapMarkerTorch_15
    const trapMarkerTorch_15 = new TrapMarkerTorch(scene, 2428, -318);
    this.add(trapMarkerTorch_15);

    // trapMarkerTorch_16
    const trapMarkerTorch_16 = new TrapMarkerTorch(scene, 2630, -315);
    this.add(trapMarkerTorch_16);

    // gemMarker_52
    const gemMarker_52 = new SmallGemMarker(scene, 4359, 237);
    this.add(gemMarker_52);

    // gemMarker_53
    const gemMarker_53 = new SmallGemMarker(scene, 5705, 231);
    this.add(gemMarker_53);

    // gemMarker_54
    const gemMarker_54 = new SmallGemMarker(scene, 7103, 226);
    this.add(gemMarker_54);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 348, 175);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 1716, 120);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 9601, 135);
    this.add(checkpointMarker_2);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // smashableMarkerRocks_1 (components)
    const smashableMarkerRocks_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_1);
    smashableMarkerRocks_1SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerRocks (components)
    const smashableMarkerRocksSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks);
    smashableMarkerRocksSimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerRocks_2 (components)
    const smashableMarkerRocks_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_2);
    smashableMarkerRocks_2SimpleBreakableBlocker.allowedCharacter = "grizz";

    // smashableMarkerRocks_3 (components)
    const smashableMarkerRocks_3SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_3);
    smashableMarkerRocks_3SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerRocks_6 (components)
    const smashableMarkerRocks_6SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_6);
    smashableMarkerRocks_6SimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerRocks_4 (components)
    const smashableMarkerRocks_4SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_4);
    smashableMarkerRocks_4SimpleBreakableBlocker.allowedCharacter = "grizz";

    // smashableMarkerRocks_5 (components)
    const smashableMarkerRocks_5SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_5);
    smashableMarkerRocks_5SimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerRocks_7 (components)
    const smashableMarkerRocks_7SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_7);
    smashableMarkerRocks_7SimpleBreakableBlocker.allowedCharacter = "grizz";

    // smashableMarkerRocks_8 (components)
    const smashableMarkerRocks_8SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_8);
    smashableMarkerRocks_8SimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerRocks_9 (components)
    const smashableMarkerRocks_9SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_9);
    smashableMarkerRocks_9SimpleBreakableBlocker.allowedCharacter = "grizz";

    // smashableMarkerRocks_11 (components)
    const smashableMarkerRocks_11SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_11);
    smashableMarkerRocks_11SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerRocks_12 (components)
    const smashableMarkerRocks_12SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_12);
    smashableMarkerRocks_12SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerRocks_13 (components)
    const smashableMarkerRocks_13SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_13);
    smashableMarkerRocks_13SimpleBreakableBlocker.allowedCharacter = "grizz";

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
